import React, { useState, useRef, useEffect } from 'react';
import Navbar from '../components/navbar';
import CTAButton from '../components/sticky-button';
import Footer from '../components/Footer';
import PageHeader from '../about/PageHeader';

// Using SVG icons as inline components
const Icons = {
  Grid: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>,
  List: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>,
  Download: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>,
  Print: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8"/></svg>,
  Share: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>,
  Minus: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="5" y1="12" x2="19" y2="12"/></svg>,
  Plus: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>,
  Cursor: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 3l7.07 16.97 2.51-7.39 7.39-2.51L3 3z"/></svg>,
  Hand: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 11V6a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v0"/><path d="M14 10V4a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v2"/><path d="M10 10.5V6a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v8"/><path d="M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15"/></svg>,
  Maximize: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"/></svg>,
  Minimize: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"/></svg>
};

const UoMQualification = () => {
  const [activePage, setActivePage] = useState(1);
  const [zoomLevel, setZoomLevel] = useState(100);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const containerRef = useRef(null);

  // PDF Source Path
  const pdfSource = "/pdf/Career/UoM-Qualification-Equivalence.pdf"; 
  const fileName = "UoM-Qualification-Equivalence.pdf";

  const handleZoomIn = () => setZoomLevel(prev => Math.min(prev + 10, 200));
  const handleZoomOut = () => setZoomLevel(prev => Math.max(prev - 10, 50));

  // Toggle Full Screen Logic
  const toggleFullScreen = () => {
    if (!document.fullscreenElement) {
      containerRef.current.requestFullscreen().catch(err => {
        console.error(`Error attempting to enable full-screen mode: ${err.message}`);
      });
    } else {
      document.exitFullscreen();
    }
  };

  // Download Logic
  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = pdfSource;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Print Logic
  const handlePrint = () => {
    // Create a hidden iframe to perform the print action
    const iframe = document.createElement('iframe');
    iframe.style.position = 'absolute';
    iframe.style.width = '0px';
    iframe.style.height = '0px';
    iframe.style.border = 'none';
    iframe.src = pdfSource;

    document.body.appendChild(iframe);

    iframe.onload = function() {
      // Small delay to ensure content is fully ready
      setTimeout(function() {
        if (iframe.contentWindow) {
          try {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
          } catch (e) {
            console.warn("Print via iframe failed, falling back to new window.");
            window.open(pdfSource, '_blank');
          }
        }
        // Cleanup the iframe after a delay to allow the print dialog to register
        setTimeout(() => document.body.removeChild(iframe), 2000);
      }, 500);
    };
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };
    document.addEventListener('fullscreenchange', handleFullscreenChange);
    return () => document.removeEventListener('fullscreenchange', handleFullscreenChange);
  }, []);

  // Set hardcoded 15 pages
  const totalPages = 15; 
  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <>
      <Navbar />
      <CTAButton />
      <div className="sh-wrapper">
        {/* Header Section */}
        <PageHeader
          title="Qualification Equivalence (University of Mumbai)"
          crumbs={[{ label: 'Home', href: '/' }, { label: 'Qualification Equivalence (University of Mumbai)' }]}
        />
        <div className="sh-container" ref={containerRef}>
          {/* Header */}
          <header className="sh-top-bar">
            <div className="sh-file-info">
              <span className="sh-file-name">Qualification Equivalence (University of Mumbai)</span>
            </div>
            
            <div className="sh-top-actions">
              <div className="sh-zoom-controls">
                <button className="sh-btn-icon" onClick={handleZoomOut}><Icons.Minus /></button>
                <span className="sh-zoom-level">{zoomLevel}%</span>
                <button className="sh-btn-icon" onClick={handleZoomIn}><Icons.Plus /></button>
              </div>
              
              <div className="sh-icon-group">
                <button className="sh-btn-icon" onClick={handleDownload} title="Download PDF">
                  <Icons.Download />
                </button>

                {/* Print Button with functionality */}
                <button className="sh-btn-icon" onClick={handlePrint} title="Print PDF">
                  <Icons.Print />
                </button>
                
                <button 
                  className="sh-btn-icon" 
                  onClick={toggleFullScreen}
                  title={isFullscreen ? "Exit Full Screen" : "Full Screen"}
                >
                  {isFullscreen ? <Icons.Minimize /> : <Icons.Maximize />}
                </button>
              </div>
            </div>
          </header>

          {/* Main Workspace */}
          <div className="sh-workspace">
            
            {/* Sidebar Navigation */}
            <aside className="sh-sidebar">
              <div className="sh-sidebar-header">
                <div className="sh-nav-title">
                  <span>Navigation</span>
                  <span className="sh-page-count">{totalPages} PAGES</span>
                </div>
              </div>

              <div className="sh-thumbnail-list">
                {pages.map((page) => (
                  <div 
                    key={page}
                    className="sh-thumb-wrapper"
                  >
                    <span className="sh-thumb-label-top">Page {page}</span>
                    <div 
                      className={`sh-thumb-item ${activePage === page ? 'active' : ''}`}
                      onClick={() => setActivePage(page)}
                    >
                      <div className="sh-thumb-preview">
                         <iframe 
                           src={`${pdfSource}#page=${page}&view=Fit&toolbar=0&navpanes=0&scrollbar=0&statusbar=0&messages=0`}
                           title={`Thumbnail Page ${page}`}
                           className="sh-thumb-iframe"
                           tabIndex="-1"
                           loading="lazy"
                         />
                         <div className="sh-thumb-overlay"></div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </aside>

            {/* Main PDF Viewer Area */}
            <main className="sh-main-view">
              <div 
                className="sh-document-page" 
                key={activePage} // <--- Adding this key re-triggers the "Rise" animation on page change
                style={{ 
                  transform: `scale(${zoomLevel / 100})`, 
                  transformOrigin: 'top center' 
                }}
              >
                <iframe 
                  key={activePage} 
                  src={`${pdfSource}#page=${activePage}&toolbar=0&navpanes=0&scrollbar=0&view=FitH`}
                  className="sh-pdf-frame"
                  title="Main PDF Viewer"
                  frameBorder="0"
                />
              </div>
            </main>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default UoMQualification;